import { useAuthStore } from "../store/auth.store";

export const useAuth = () => {
  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);
  const initialized = useAuthStore((state) => state.initialized);
  const login = useAuthStore((state) => state.login);
  const logout = useAuthStore((state) => state.logout);

  // Función para verificar roles
  const hasRole = (roles) => {
    if (!user || !user.roles || user.roles.length === 0) return false;

    // Extraer los nombres de los roles (pueden ser strings u objetos)
    const userRoleNames = user.roles.map(r => r.name || r);

    if (typeof roles === 'string') {
      return userRoleNames.includes(roles);
    }
    return roles.some(role => userRoleNames.includes(role));
  };

  // Permisos específicos
  const isAdmin = () => hasRole('admin');
  const isSupervisor = () => hasRole('supervisor');
  const isFinanzas = () => hasRole('finanzas');
  const isTecnicoCampo = () => hasRole('tecnico_campo');
  const isSoporte = () => hasRole(['soporte_n1', 'soporte_n2']);
  const isRecaudacion = () => hasRole('Recaudacion');
  const isBodeguero = () => hasRole('bodeguero');

  // Permisos compuestos
  const canExport = () => hasRole(['admin', 'supervisor']);
  const canManageFinanzas = () => hasRole(['admin', 'finanzas']);
  const canDelete = () => hasRole(['admin']);
  const canViewTickets = () => hasRole(['admin', 'supervisor', 'soporte_n1', 'soporte_n2', 'tecnico_campo']);
  const canViewMikrotik = () => hasRole(['admin', 'supervisor', 'soporte_n2']);

  return {
    isAuthenticated: !!token,
    initialized,
    user,
    login,
    logout,
    // Nuevas funciones de permisos
    hasRole,
    isAdmin,
    isSupervisor,
    isFinanzas,
    isTecnicoCampo,
    isSoporte,
    isRecaudacion,
    canExport,
    canManageFinanzas,
    canDelete,
    canViewTickets,
    canViewMikrotik
  };
};
